import { useShopCountry } from '@cbgms/base/shop-country'
import { ShopCountry } from '@cbgms/base/shop-id'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface IURLStore {
  [key: string]: { [key: string]: string }
}

// Preparation for Multiple language file
export const documentUrls: IURLStore = {
  [ShopCountry.GB]: { en: 'https://carsys.s3-eu-central-1.amazonaws.com/public/documents/haynespro/HaynesPro_EULA_GB_en.pdf' },
  [ShopCountry.BE]: {
    nl: 'https://carsys.s3-eu-central-1.amazonaws.com/public/documents/haynespro/HaynesPro_EULA_BE_nl.pdf',
    fr: 'https://carsys.s3-eu-central-1.amazonaws.com/public/documents/haynespro/HaynesPro_EULA_BE_fr.pdf'
  },
  [ShopCountry.DE]: { de: 'https://carsys.s3-eu-central-1.amazonaws.com/public/documents/haynespro/HaynesPro_EULA_DE_de.pdf' },
  [ShopCountry.FR]: { fr: 'https://carsys.s3-eu-central-1.amazonaws.com/public/documents/haynespro/HaynesPro_EULA_FR_fr.pdf' },
  [ShopCountry.NL]: { nl: 'https://carsys.s3-eu-central-1.amazonaws.com/public/documents/haynespro/HaynesPro_EULA_NL_nl.pdf' }
}

export const getDocumentURLForShopAndLocale = (shopCountry?: ShopCountry, userLanguage?: string) => {
  if (!shopCountry) {
    return ''
  }
  // we try to match the user language, but if it's not available we fall try a fallback
  const envDocuments = documentUrls[shopCountry]
  if (!envDocuments) {
    return ''
  }

  // return in language of user, of fallback to default
  const defaultForEnv = envDocuments[Object.keys(envDocuments)[0]]
  if (!userLanguage || !envDocuments[userLanguage]) return defaultForEnv

  return envDocuments[userLanguage]
}

const SetupWizardStepHaynesProEula: React.FC<{}> = () => {
  const { t } = useTranslation()
  const { country } = useShopCountry()
  const { i18n } = useTranslation()

  const uelaURL = useMemo(() => {
    const lang = i18n.language?.split('-')[0] // pick only the language
    return getDocumentURLForShopAndLocale(country, lang)
  }, [country])

  return (
    <>
      {t('SetupWizard.HaynesProSummary')}
      <a href={uelaURL} target='_blank'>
        {t('SetupWizard.HaynesProEULAFile')}
      </a>
    </>
  )
}

export default SetupWizardStepHaynesProEula
